/************************************
1. If you want to add or remove items you will need to change a variable called $slide-count in the CSS *minimum 3 slides

2. if you want to change the dimensions of the slides you will need to edit the slideWidth variable here 👇 and the $slide-width variable in the CSS.
************************************/
import React from "react";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const options = {
  responsive: {
    0: {
      items: 1,
    },
    400: {
      items: 1,
    },
    600: {
      items: 2,
    },
    700: {
      items: 2,
    },
    1000: {
      items: 3.5,
    },
  },
};

const Mobroad = () => {
  return (
    <>
      <div className="roadmap_section mob-road mob-percent">
        {/* <!-- live auctions --> */}
        <section className="inner">
          {/* carousel  */}
          <div className="col-12">
            <OwlCarousel
              className="owl-theme hero chords"
              loop
              margin={10}
              nav
              id="hero"
              autoheight="true"
              {...options}
              style={{ marginTop: "0", padding: "28px 0px 0px 0px" }}
            >
              <div className="card p-3 mb-2 ecocard home_little">
                <h2 className="stats">25%</h2>
                <div className="mt-3">
                  {" "}
                  <p className="ecosystempara2 home_p">
                    of the <b>Opensea Royalties</b> are used
                    <br /> to buy up $LITTLE tokens from the exchanges and burn
                    them.
                  </p>
                </div>
              </div>
              <div className="card p-3 mb-2 ecocard home_little">
                <h2 className="stats">20%</h2>
                <div className="mt-3">
                  {" "}
                  <p className="ecosystempara2 home_p">
                    of the <b>NFT Marketplace fees</b> are used to buy
                    <br /> $LITTLE tokens from the exchange and burned them.
                  </p>
                </div>
              </div>
            </OwlCarousel>
          </div>
          {/* end carousel  */}
        </section>
        {/* end live auctions */}
      </div>
    </>
  );
};

export default Mobroad;
